module.exports = __webpack_public_path__ + "static/media/02_Maf_NuestroEquipo_GralMarioFromow.1fe0a063.png";